import React from 'react';

function MatchMediaUpload({
  isMatchMediaExpanded,
  setIsMatchMediaExpanded,
  data,
  setData,
  handleMatchMediaUpload
}) {
  return (
    <section style={{
      background: "white",
      borderRadius: "16px",
      padding: "24px",
      marginBottom: "24px",
      border: "1px solid var(--border)",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: isMatchMediaExpanded ? "12px" : "0px",
        cursor: "pointer"
      }}
      onClick={() => {
        const newExpanded = !isMatchMediaExpanded;
        setIsMatchMediaExpanded(newExpanded);
      }}
      >
        <h2 style={{
          fontSize: "18px",
          fontWeight: "600",
          margin: "0",
          color: "#000000"
        }}>
          Match Media
        </h2>
        <button
          type="button"
          style={{
            background: "none",
            border: "none",
            fontSize: "16px",
            color: "var(--muted)",
            cursor: "pointer",
            transform: isMatchMediaExpanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease"
          }}
        >
          ▼
        </button>
      </div>

      {isMatchMediaExpanded && (
        <div>
          <div style={{
            border: "2px dashed var(--border)",
            borderRadius: "12px",
            padding: "24px",
            textAlign: "center",
            background: "#f8f9fa",
            transition: "all 0.3s ease",
            cursor: "pointer",
            marginBottom: "16px"
          }}
          onClick={() => document.getElementById('match-media-upload').click()}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "var(--primary)";
            e.currentTarget.style.background = "#f0f9ff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "var(--border)";
            e.currentTarget.style.background = "#f8f9fa";
          }}
          >
            <input
              id="match-media-upload"
              type="file"
              accept="image/*"
              multiple
              style={{ display: "none" }}
              onChange={handleMatchMediaUpload}
            />
            
            {data.matchMedia && data.matchMedia.length > 0 ? (
              <div>
                <div style={{ fontSize: "32px", marginBottom: "12px" }}>📁</div>
                <div style={{ fontSize: "16px", color: "var(--text)", marginBottom: "6px", fontWeight: "500" }}>
                  {data.matchMedia.length} file(s) uploaded
                </div>
                <div style={{ fontSize: "14px", color: "var(--muted)", marginBottom: "16px" }}>
                  Click to add more or remove files
                </div>
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setData(prev => ({ ...prev, matchMedia: [] }));
                  }}
                  style={{
                    background: "#dc3545",
                    color: "white",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    cursor: "pointer",
                    fontWeight: "500"
                  }}
                >
                  Remove All Files
                </button>
              </div>
            ) : (
              <div>
                <div style={{ fontSize: "16px", color: "var(--text)", marginBottom: "12px", fontWeight: "500" }}>
                  Click to upload photos
                </div>
                <div style={{ fontSize: "14px", color: "var(--muted)", textAlign: "left", maxWidth: "300px", margin: "0 auto" }}>
                  <div style={{ marginBottom: "4px" }}>• Images: Max 2MB</div>
                  <div>• Supported formats: JPG, PNG, GIF</div>
                </div>
              </div>
            )}
          </div>

          {/* Media Preview */}
          {data.matchMedia && data.matchMedia.length > 0 && (
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
              gap: "12px"
            }}>
              {data.matchMedia.map((media, index) => (
                <div key={index} style={{
                  position: "relative",
                  background: "#f8f9fa",
                  borderRadius: "8px",
                  overflow: "hidden",
                  border: "1px solid var(--border)"
                }}>
                  {media.type === 'image' ? (
                    <img 
                      src={media.url} 
                      alt={media.name}
                      style={{
                        width: "100%",
                        height: "80px",
                        objectFit: "cover"
                      }}
                    />
                  ) : (
                    <div style={{
                      width: "100%",
                      height: "80px",
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "24px"
                    }}>
                      🎥
                    </div>
                  )}
                  <div style={{
                    position: "absolute",
                    top: "4px",
                    right: "4px",
                    background: "rgba(0, 0, 0, 0.7)",
                    color: "white",
                    borderRadius: "4px",
                    padding: "2px 6px",
                    fontSize: "10px",
                    fontWeight: "500"
                  }}>
                    IMG
                  </div>
                  <div style={{
                    padding: "8px",
                    fontSize: "12px",
                    color: "var(--text)",
                    fontWeight: "500",
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }}>
                    {media.name}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </section>
  );
}

export default MatchMediaUpload;